<template>
  <nav class="navbar-mobile">
    <div class="navbar-header">
      <button class="navbar-toggle" @click="toggleMenu">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div class="navbar-brand">
        <img
          src="../assets/img/index/logo.png"
          alt=""
          style="width: 30px; height: 30px"
        />
        <div class="headerBox">
          <span class="span1">Innovative Pay</span>
        </div>
      </div>

      <custom-dropdown @selected="handleSelection"></custom-dropdown>
    </div>
    <ul class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
      <li>
        <router-link to="/" @click.native="closeMenu"
          >‌{{ $t("home") }}</router-link
        >
      </li>
      <li>
        <router-link to="/aboutPage" @click.native="closeMenu"
          >‌{{ $t("Solution") }}</router-link
        >
      </li>
      <li>
        <router-link to="/ourSecurity" @click.native="closeMenu">{{
          $t("Focused")
        }}</router-link>
      </li>
      <li>
        <router-link to="/ourHelp" @click.native="closeMenu">{{
          $t("Technology")
        }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import CustomDropdown from "./CustomDropdown.vue"

export default {
  name: "NavbarMobile",
  components: {
    CustomDropdown,
  },
  data() {
    return {
      isMenuOpen: false,
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    handleSelection(option) {
      console.log("选中的选项:", option)

      const newLocale = option === "English" ? "en" : "ur"
      this.$i18n.locale = newLocale

      if (typeof localStorage !== "undefined") {
        localStorage.setItem("locale", newLocale)
      }

      if (typeof document !== "undefined") {
        const html = document.documentElement
        html.setAttribute("dir", newLocale === "ur" ? "rtl" : "ltr")
        html.setAttribute("lang", newLocale)
      }
    },
    closeMenu() {
      this.isMenuOpen = false
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.navbar-mobile {
  background-color: #f8f9fa;
  width: 100vw;
  padding: 1.3rem;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: var(--primaryColor);
  color: var(--fontColor);
  z-index: 1000;
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar-brand img {
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
  margin-right: 1.25rem;
}
.headerBox {
  display: flex;
  flex-direction: column;
}
.span1 {
  font-weight: 500;
  font-size: 2rem;
  color: #ffffff;
}
.span2 {
  font-size: 1.25rem;
}
.navbar-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1.5rem;
}

.icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  background-color: #fff;
  margin: 4px 0;
}

.navbar-menu {
  list-style: none;
  padding: 0;

  margin: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.navbar-menu.is-active {
  /* padding-top: 6rem; */
  max-height: 300px;
}

.navbar-menu li {
  padding: 1.5rem 0;
}

a {
  /* width: 150px; */
  width: 200px;
  color: #fff;
  height: 3.3125rem;
  /* line-height: 3.3125rem; */
  text-decoration: none;
  display: block;
  align-items: center;
  font-size: 1.8rem;
  padding: 0 6rem;
}

.navbar-menu a:hover {
  color: var(--primaryColor);
  background-color: #fff;

  border-radius: 4.8rem;
}

.router-link-exact-active {
  color: var(--primaryColor);
  background-color: #fff;

  border-radius: 4.8rem;
}

@media (min-width: 992px) {
  .navbar-mobile {
    display: none;
  }
}
[dir="rtl"] .navbar-mobile {
  direction: ltr;
}
[dir="rtl"] .navbar-brand img {
  transform: none;
}
</style>
